import MyContainer from "@/components/MyContainer";
import FulfillmentForm from "@/pages/fulfillment/form/fulfillment-form";
import { useGetFulfillment } from "@/services/fulfillment-service";
import { Box } from "@mui/material";
import { useParams } from "wouter";

export function EditFulfillmentPage() {
  const params = useParams();
  const fulfillmentId = params.id?.toString();

  if (!fulfillmentId) {
    return (
      <MyContainer title="Edit Fulfillment" subtitle="Edit fulfillment">
        <div>Fulfillment not found</div>
      </MyContainer>
    );
  }

  const { data: initialValues, isLoading } = useGetFulfillment(fulfillmentId);

  if (isLoading) {
    return (
      <MyContainer title="Edit Fulfillment" subtitle="Edit fulfillment">
        <Box sx={{ p: 2, color: "text.secondary" }}>Loading…</Box>
      </MyContainer>
    );
  }

  if (!initialValues) {
    return (
      <MyContainer title="Edit Fulfillment" subtitle="Edit fulfillment">
        <Box sx={{ p: 2, color: "text.secondary" }}>Fulfillment not found</Box>
      </MyContainer>
    );
  }

  return (
    <MyContainer title="Edit Fulfillment" subtitle="Edit fulfillment">
      <FulfillmentForm mode="update" initialValues={initialValues} />
    </MyContainer>
  );
}
